<template>
    <!-- insert team config form -->
    <div class="p-col-12 p-md-11 p-mx-auto p-mt-2">
        <div class="p-text-right">
            <Button
                label="Add New Config"
                v-show="serviceList !== undefined && serviceList !== null && serviceList.length > 0"
                @click="toggleNewConfigForm()"
                class="p-button-sm p-button-text p-button-outlined p-button-info p-text-right" /> 
        </div>
    </div>

    <transition name="expand">
    <div v-show="isNewConfigFormVisible" class="p-grid p-jc-center p-p-4">
        <div class="card p-col-12 p-md-9 p-mx-auto p-p-4">
            <div class="p-grid">
                <div class="p-col-12 p-md-2">
                    <Dropdown class="p-text-left" style="width: 100% !important" placeholder="Select Organization"
                        v-model="newConfigForm.selectedOrganizationId" :options="organizations" optionLabel="name" optionValue="id"
                        :loading="isOrganizationListLoading"
                        @change="organizationSelected($event)" />
                </div>
                <div class="p-col-12 p-md-2">
                    <Dropdown class="p-text-left" style="width: 100% !important" placeholder="Select Source"
                        v-model="newConfigForm.source" :options="newConfigForm.selectedOrganization.sources" optionLabel="name" optionValue="code"
                        v-show="newConfigForm.selectedOrganizationId !== undefined && newConfigForm.selectedOrganizationId !== null
                            && newConfigForm.selectedOrganizationId > 0"
                        @change="sourceSelected($event)" />
                </div>
                <div class="p-col-12 p-md-2">
                    <Dropdown class="p-text-left" style="width: 100% !important" placeholder="Select Team"
                        v-model="newConfigForm.selectedTeamId" :options="newConfigForm.selectedOrganization.teams" optionLabel="name" optionValue="id"
                        v-show="newConfigForm.source !== undefined && newConfigForm.source !== null"
                        :loading="isTeamListLoading"
                        @change="teamSelected($event)" />
                </div>
                <div class="p-col-12 p-md-3">
                    <span class="p-float-label"
                        v-show="newConfigForm.selectedTeamId !== undefined && newConfigForm.selectedTeamId !== null">
                        <InputText class="p-col-12" id="new_name" type="text" v-model="newConfigForm.newName" />
                        <label for="new_name">New name</label>
                    </span>
                </div>
                <div class="p-col-12 p-md-3">
                    <span class="p-float-label"
                        v-show="newConfigForm.selectedTeamId !== undefined && newConfigForm.selectedTeamId !== null">
                        <Textarea class="p-col-12" id="comment" type="text" rows="2" :autoResize="true" v-model="newConfigForm.comment" />
                        <label for="comment">Comment</label>
                    </span>
                </div>
            </div>
            <div class="p-grid p-jc-end p-m-0 p-pt-2">
                <Button @click="addConfig()" label="Insert Team Config" class="p-button p-button-info" />
            </div>
        </div>
    </div>
    </transition>

    <ProgressBar mode="indeterminate" v-show="isItemListLoading" style="height: .2em" />

    <!-- config datatable -->
    <div class="p-grid">
        <div class="p-col-12 p-md-11 p-mx-auto p-mt-2">
            <DataTable v-show="configList !== null && configList.length > 0" :paginator="true" :rows="25" :rowHover="true"
                :value="configList" editMode="row" dataKey="id" v-model:filters="filters" filterDisplay="menu"
                v-model:editingRows="editingRows" @row-edit-save="onRowEditSave" responsiveLayout="scroll"
                :globalFilterFields="['tournament_name', 'team_name', 'team_name_original']" >
                <Column field="tournament_name" header="Tournament" sortable style="width:10%"></Column>
                <Column field="service" header="Service" sortable style="width:10%">
                    <template #body="{data}">
                        {{getServiceName(data.service)}}
                    </template>
                </Column>
                <Column field="team_id" header="Team Id" sortable style="width:10%"></Column>
                <Column field="team_name_original" header="Original Name" sortable style="width:15%"></Column>
                <Column field="team_name" header="Team Name" sortable style="width:15%">
                    <template #body="{data}">
                        {{data.team_name}}
                    </template>
                    <template #editor="{data, field}">
                        <InputText v-model="data[field]" placeholder="Team Name" class="p-col-12" id="team_name" type="text" />
                    </template>
                </Column>
                <Column field="comment" header="Comment" style="width:15%">
                    <template #body="{data}">
                        <div v-html="getFormattedComment(data.comment)"></div>
                    </template>
                    <template #editor="{data, field}">
                        <Textarea v-model="data[field]" rows="2" :autoResize="true"
                            placeholder="Comment" class="p-col-12" id="comment" />
                    </template>
                </Column>
                <Column field="last_updated_date" header="Last Update" sortable dataType="date" class="p-text-center" style="width:10%; line-height: 1.25rem;">
                    <template #body="{data}">
                        <div v-html="getFormattedDate(data.last_updated_date)" style="width:100%"></div>
                    </template>
                    <template #editor="{}"></template>
                </Column>
                <Column :rowEditor="true" style="width:10%" bodyStyle="text-align:right;"></Column>
                <Column header="" style="width:5%" bodyStyle="text-align:left;">
                    <template #body="item">
                    <div style="">
                        <Button label="" icon="pi pi-trash" class="p-button-rounded p-button-text p-button-plain"
                        @click="deleteConfig(item.data.id)" />
                    </div>
                    </template>
                    <template #editor="{}"></template>
                </Column>
            
            </DataTable>
        </div>
    </div>

    <p>
        Config Team
        TODO:
        - ConfigLabel'dan kopyalanarak devam edilecek...
        - Add New Config ile modal popup açılacak.
            - Servis seçiminden sonra apiden seçilen servisin puan tablosu çektirilecek.
            - Takım listesi Dropdown'a yüklenecek.
            - Seçilen takım için (team id elde etmiş olduk) yeni adı girilecek ve kaydedilecek
        - Düzenleme de aynı şekilde modal popup ile yapılacak.
            - Servis için puan tablosu elde edildiyse takımları bir dizide saklayalım,
              diğer takımların adlarını düzenlerken tekrar tekrar servisi çağrısına gerek kalmaz....
              teamList[service] = [] // teamList['ss'] = [] gibi yani
        - Config ekranlarının altına about açıklamalar eklenecek
    </p>
</template>

<script>
import { FilterMatchMode } from 'primevue/api'
import ProgressBar from 'primevue/progressbar'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'
import Dropdown from 'primevue/dropdown'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'

import Const from '../utils/const'
import { isEmpty } from '../utils/utils'
import moment from 'moment'

export default {
    name: 'ConfigTeam',
    emits: ["loginResult", "pageLoaded"],
    components: {
        ProgressBar, Button, InputText, Textarea, Dropdown, DataTable, Column
    },
    beforeMount() {
        var page = {
            title: "Team Config"
        }
        this.$emit('pageLoaded', page)
    },
    mounted() {
        this.loadServiceList()
    },
    data() {
        return {
            serviceList: [],
            isItemListLoading: false,
            configList: [],
            isNewConfigFormVisible: false,
            newConfigForm: {
                selectedOrganization: {
                    name: '', // secilen turnuvanin adi,
                    sources: [], // secilen turnuva icin set edilmis servisler. (ss, of vb. listesi)
                    teams: [], // secilen turnuvanin secilen servisten getirilen takim listesi
                },
                source: null, // secilen servis kaynagi (ss, of)
                selectedTeamId: null, // secilen takim id
                newName: null, // takimin yeni adi
                originalName: null, // takimin secilen servisteki orjinal adi
                comment: null
            },
            organizations: [],
            isOrganizationListLoading: false,
            isTeamListLoading: false,
            editingRows: [],
            filters: {
                'tournament_name': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'team_name': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'team_name_original': {value: null, matchMode: FilterMatchMode.CONTAINS}
            },
        }
    },
    methods: {
        loadServiceList() {
            let self = this,
                cookies = self.$cookies,
                toast = self.$toast,
                token = cookies.get('token');

            self.isItemListLoading = true
            self.$http.get('api/config/label/services', {
                headers: {
                'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                self.isItemListLoading = false
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    self.serviceList = response.data.items

                    self.loadConfig()
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity:'warn', summary: 'Loading team services failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                self.isItemListLoading = false
                toast.add({severity:'error', summary: 'Error', detail:err});
                console.log(err)
            });
        },
        loadConfig() {
            let self = this,
                cookies = self.$cookies,
                toast = self.$toast,
                token = cookies.get('token');

            self.isItemListLoading = true
            self.$http.get('api/config/team', {
                headers: {
                'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                self.isItemListLoading = false
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    self.configList = response.data.items
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity:'warn', summary: 'Loading team config failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                self.isItemListLoading = false
                toast.add({severity:'error', summary: 'Error', detail:err});
                console.log(err)
            });
        },
        toggleNewConfigForm() {
            let self = this,
                organizations = self.organizations

            self.isNewConfigFormVisible = !self.isNewConfigFormVisible

            if(organizations === undefined || organizations === null || organizations.length === 0) {
                self.loadOrganizations()
            }
        },
        loadOrganizations() {
            let self = this,
                toast = self.$toast,
                cookies = self.$cookies,
                token = cookies.get('token');
            
            self.isOrganizationListLoading = true
            self.$http.get('api/config/organization/all-set', {
                headers: {
                'authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.isOrganizationListLoading = false
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    self.organizations = response.data.items
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity:'warn', summary: 'Loading organizations failed', detail:response.data.mesaj, life: 3000});
                }
            }).catch(function (err) {
                self.isOrganizationListLoading = false
                toast.add({severity:'error', summary: 'Error', detail:err});
                console.log(err)
            });
        },
        organizationSelected(event) {
            let self = this

            // sonraki source ve takim secimlerini resetle
            self.newConfigForm.source = null
            self.newConfigForm.team = null
            self.newConfigForm.originalName = null

            self.organizations.forEach(item => {
                if(item.id === event.value) {
                    self.newConfigForm.selectedOrganization = item
                    self.newConfigForm.selectedOrganization.name = item.name
                    return
                }
            })
        },
        sourceSelected(event) {
            let self = this,
                selectedSource = event.value,
                toast = self.$toast,
                cookies = self.$cookies,
                token = cookies.get('token');

            // sonraki takim secimini resetle
            self.newConfigForm.team = null
            self.newConfigForm.originalName = null

            var tournamentId = '';
            if(selectedSource === 'ss') {
                tournamentId = self.newConfigForm.selectedOrganization.ss_unique_tournament_id;
            } else if(selectedSource === 'of') {
                tournamentId = self.newConfigForm.selectedOrganization.of_id;
            }

            var seasonId = '';
            if(selectedSource === 'ss') {
                seasonId = self.newConfigForm.selectedOrganization.ss_season_id;
            } else if(selectedSource === 'of') {
                seasonId = self.newConfigForm.selectedOrganization.of_season_id;
            }

            self.isTeamListLoading = true
            self.$http.get('api/tournaments/source/'+selectedSource+'/'+tournamentId+'/season/'+seasonId+'/teams', {
                headers: {
                'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                self.isTeamListLoading = false
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    self.newConfigForm.selectedOrganization.teams = response.data.items
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity:'warn', summary: 'Loading teams failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                self.isTeamListLoading = false
                toast.add({severity:'error', summary: 'Error', detail:err});
                console.log(err)
            });
        },
        teamSelected(event) {
            let originalTeam = this.newConfigForm.selectedOrganization.teams.find(team => team.id === event.value)
            this.newConfigForm.originalName = originalTeam.name
        },
        addConfig() {
            let self = this,
                toast = self.$toast,
                newConfigForm = self.newConfigForm,
                toastMessage = null,
                token = self.$cookies.get('token');

            if(newConfigForm.selectedTeamId === undefined || newConfigForm.selectedTeamId === null) {
                toastMessage = 'Team is not selected!'
            } else if(newConfigForm.selectedOrganization === undefined || newConfigForm.selectedOrganization === null) {
                toastMessage = 'Organization is not selected!'
            } else if(newConfigForm.source === undefined || newConfigForm.source === null) {
                toastMessage = 'Source is not selected!'
            } else if(isEmpty(newConfigForm.originalName)) {
                toastMessage = 'Original team name is empty!'
            } else if(isEmpty(newConfigForm.newName)) {
                toastMessage = 'New team name is empty!'
            }

            if(!isEmpty(toastMessage)) {
                toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
                return
            }

            let payload = {
                service: newConfigForm.source,
                team_id: newConfigForm.selectedTeamId,
                team_name: newConfigForm.newName,
                team_name_original: newConfigForm.originalName,
                tournament_name: newConfigForm.selectedOrganization.name,
                comment: newConfigForm.comment
            }

            self.$http.post('api/config/team', payload, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    self.$cookies.set('token', response.headers['refresh-token']);
                    let newAddedItem = response.data.item
                    
                    self.configList.push(newAddedItem)

                    toast.add({severity:'success', summary: 'Success', detail: 'Team config added successfully.', life: 3000});

                    // input alanlarini resetle
                    self.newConfigForm.selectedTeamId = null
                    self.newConfigForm.newName = null
                    self.newConfigForm.originalName = null
                    self.newConfigForm.comment = null
                } else {
                    console.log(response)
                    toast.add({severity:'warn', summary: 'Team config insert failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                console.log(err)
                toast.add({severity: 'error', summary: 'Error', detail: err});
            });
        },
        onRowEditSave(event) {
            let { newData, index } = event;

            let self = this,
                configId = newData.id,
                toast = self.$toast,
                toastMessage = null,
                cookies = self.$cookies,
                token = self.$cookies.get('token');

            if(isEmpty(newData.team_name)) {
                toastMessage = 'New team name is empty!'
            }

            if(!isEmpty(toastMessage)) {
                toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
                return
            }

            let payload = {
                team_id: newData.team_id,
                team_name: newData.team_name,
                comment: newData.comment
            }

            self.$http.put('api/config/team/'+configId, payload, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    
                    self.configList[index] = response.data.item;

                    toast.add({severity:'success', summary: 'Success', detail: 'Updated successfully.', life: 3000});
                } else {
                    toast.add({severity:'warn', summary: 'Update failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                console.log(err)
                toast.add({severity: 'error', summary: 'Error', detail: err});
            });
        },
        deleteConfig(configId) {
            let self = this,
                toast = self.$toast,
                cookies = self.$cookies,
                token = self.$cookies.get('token');
            
            this.$confirm.require({
                message: 'Are you sure you want to delete this team config permanently?',
                header: 'Delete',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Delete',
                rejectLabel: 'Cancel',
                accept: () => {
                    self.$http.delete('api/config/team/'+configId, {
                        headers: {
                            'authorization': 'Bearer ' + token
                        }
                    })
                    .then(function (response) {
                        if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                            cookies.set("token", response.headers['refresh-token']);

                            self.loadConfig()

                            toast.add({severity:'success', summary: 'Success', detail: 'Team config deleted successfully.', life: 3000});
                        } else {
                            console.log(response)
                            toast.add({severity:'warn', summary: 'Team config category failed', detail:response.data.mesaj, life: 3000});
                        }
                    })
                    .catch(function (err) {
                        console.log(err)
                        toast.add({severity: 'error', summary: 'Error', detail: err});
                    });
                },
                reject: () => {
                }
            });
        },
        getServiceName(code) {
            var name = 'Service not found'
            this.serviceList.forEach(item => {
                if(item.code === code) {
                    name = item.name
                }
            })
    
            return name
        },
        getFormattedDate(logDate) {
            return moment(new Date(logDate)).format('DD/MM/YYYY HH:mm');
        },
        getFormattedComment(comment) {
            return !isEmpty(comment) ? comment.replaceAll('\n', '<br/>') : null
        }
    }
}
</script>